import { Button, Icon, Justify, Row, Theme, Tray } from '@busybusy/webapp-react-ui';
import { CloseIcon } from 'assets/icons';
import classNames from 'classnames';
import * as React from 'react';
import './ActionBar.scss';

export interface IActionBarProps {
  selectedCount: number;
  onClear: () => void;
  className?: string | object;
}

const ActionBar: React.FunctionComponent<IActionBarProps> = (props) => {
  const { onClear, selectedCount, children, className } = props;

  const classes = classNames(
    {
      'action-header': true,
      'action-header-visible': selectedCount > 0,
      'px-5': true,
    },
    className
  );

  return (
    <Row className={classes} justify={Justify.SPACE_BETWEEN}>
      {children}
      <Tray align="right">
        <span>{`${selectedCount} selected`}</span>
        <Button type="icon" theme={Theme.DARK} onClick={onClear}>
          <Icon svg={CloseIcon} />
        </Button>
      </Tray>
    </Row>
  );
};

export default ActionBar;
